<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="footer">
    <div class="footer_top">
      <div class="footer_left">
        <div class="left_head">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/logo1.png"
            alt=""
          />
          <!-- <div class="shu"></div>
          <div class="right">
            <div class="text">合作</div>
            <div class="text1">售后</div>
          </div> -->
        </div>
        <div class="left_foot">
          <div
            class="item"
            @click="jump(item.src)"
            v-for="(item, index) in images"
            :key="index"
          >
            <img v-if="item.src != ''" class="img" :src="item.img" alt="" />
            <el-popover
              v-else
              placement="top"
              trigger="hover"
              popper-class="popover"
            >
              <div class="custom-content">
                <img
                  class="img1"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sph.jpg"
                  alt=""
                  style="width: 300px"
                />
                <img
                  class="img1 img2"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sph1.jpg"
                  alt=""
                  style="width: 300px; margin-left: 20px"
                />
              </div>
              <img class="img" :src="item.img" alt="" slot="reference" />
            </el-popover>
          </div>
        </div>
      </div>
      <div class="footer_right">
        <div class="right_item right_item1">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/gzh.png"
            alt=""
          />
          <div class="text">微信公众号</div>
        </div>
        <div class="right_item">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/kf.png"
            alt=""
          />
          <div class="text">微信客服</div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="text" @click="jumpPage(0)">隐私政策</div>
      <div class="shu"></div>
      <div class="text" @click="jumpPage(1)">使用条款</div>
    </div>
    <footer class="footer-beian">
      <p class="text">© 2025 杭州二白智能科技有限公司</p>
      <p>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #777; text-decoration: none"
          >浙ICP备20005457号-4</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        {
          name: "抖音",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/dy.png",
          http: "",
          src: "https://www.douyin.com/user/MS4wLjABAAAANcdwoOeTTwylonOhdDobFeDX7CDLOhYpCiA2MaKf3Q4?from_tab_name=main",
        },
        {
          name: "快手",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/ks.png",
          http: "",
          src: "https://live.kuaishou.com/profile/BAY2nd01",
        },
        {
          name: "小红书",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/xhs.png",
          http: "",
          src: "https://www.xiaohongshu.com/search_result?keyword=%25E6%2588%2591%25E7%25B3%25BB%25E4%25BA%258C%25E7%2599%25BD&source=web_explore_feed",
        },
        {
          name: "视频号",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sp.png",
          http: "",
          src: "",
        },
        {
          name: "微博",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wb.png",
          http: "",
          src: "https://weibo.com/u/6657374642",
        },
        {
          name: "哔哩哔哩",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/bilibili.png",
          http: "",
          src: "https://space.bilibili.com/362785416?spm_id_from=333.337.0.0",
        },
      ],
    }
  },
  methods: {
    jump(url) {
      if (url != "") {
        window.open(url, "_blank")
      }
    },
    jumpPage(e) {
      if (e == 0) {
        if (this.$route.path != "/website/privacy") {
          this.$router.push("/website/privacy")
        }
      } else {
        if (this.$route.path != "/website/terms") {
          this.$router.push("/website/terms")
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  .footer_top {
    width: 100%;
    box-sizing: border-box;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background-color: #121212;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 170px;
    .footer_left {
      .left_head {
        display: flex;
        align-items: center;
        .img {
          width: 200px;
          height: 60px;
        }
        .shu {
          width: 1px;
          height: 60px;
          margin: 0 40px;
          background-color: #414141;
        }
        .right {
          display: flex;
          align-items: center;
          font-size: calc(18px * var(--scale));
          color: #414141;
          .text {
            margin-right: 30px;
            cursor: pointer;
          }
          .text1 {
            cursor: pointer;
          }
        }
      }
      .left_foot {
        display: grid;
        grid-column-gap: 1.5rem;
        grid-template-rows: auto;
        grid-template-columns: repeat(6, 1fr);
        margin-top: 20px;
        flex: 1;
        .item {
          width: 40px;
          height: 40px;
          border-radius: 100px;
          background-color: #2a2a2a;
          display: flex;
          align-items: center;
          justify-content: center;
          .img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          ::v-deep .el-popover .custom-content {
            display: flex;
            align-items: center;
            .img1 {
              width: 200px !important;
              height: 300px !important;
            }
            .img2 {
              margin-left: 20px !important;
            }
          }
        }
        .item:nth-child(3) {
          background-color: #404040;
          .img {
            width: 24px;
            height: 10px;
          }
        }
      }
    }
    .footer_right {
      display: flex;
      align-items: center;
      .right_item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .img {
          width: 110px;
          height: 110px;
          border-radius: 10px;
          margin-bottom: 15px;
        }
        .text {
          font-size: calc(16px * var(--scale));
          color: #888888;
        }
      }
      .right_item1 {
        margin-right: 50px;
      }
    }
  }
  .footer_bottom {
    width: 100%;
    background-color: #171717;
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      font-size: calc(14px * var(--scale));
      color: #666666;
      cursor: pointer;
    }
    .shu {
      width: 1px;
      height: 15px;
      background-color: #4f4f4f;
      margin: 0 24px;
    }
  }
  .footer-beian {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #777;
    background-color: #171717;
    font-size: calc(14px * var(--scale));
    .text {
      margin-right: 20px;
    }
    a {
      color: #555;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
</style>
